export default {
  paymentPlan: '{{installmentCount}} interest-free payments of {{tagOpen}}{{installmentAmount}}{{tagOpen}}',
  logoText: 'Klarna',
};
